module.exports = __webpack_public_path__ + "img/poster_count_yg.590654a2.png";